export const autocompleteConstants = {
  SUGGEST: 'SUGGEST',
  RESET: 'RESET',
  START_AUTOCOMPLETE_LOADER: 'START_AUTOCOMPLETE_LOADER',
  STOP_AUTOCOMPLETE_LOADER: 'STOP_AUTOCOMPLETE_LOADER',
};
